import React from "react";

type ErrorBoundaryProps = {
  FallbackComponent: React.ComponentType<{ error: Error }>;
};
type ErrorBoundaryState = {
  error: null | Error;
};
export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidUpdate(
    prevProps: Readonly<ErrorBoundaryProps>,
    prevState: Readonly<ErrorBoundaryState>,
  ): void {
    if (prevState.error && prevState.error === this.state.error) {
      this.setState({ error: null });
    }
  }

  render(): React.ReactNode {
    const { error } = this.state;

    if (error) {
      return <this.props.FallbackComponent error={error} />;
    }

    return this.props.children;
  }
}
